import React from 'react'
import Sidebar from './components/sidebar/Sidebar'
import Main from './components/Main/Main'

function App() {
  return (
     <>
     <Sidebar/>
     <Main/>
     </>
  )
}

export default App